module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ug-983dd591c56af488af9614a3b3fc9711.svg";